class CiqLoaderService {
    private static instance: CiqLoaderService;
    private timeoutid;
    private loaderComponent: HTMLCiqLoaderElement | null = null;
  
    private constructor() {
      this.ensureLoaderExists();
    }
  
    static getInstance(): CiqLoaderService {
      if (!CiqLoaderService.instance) {
        CiqLoaderService.instance = new CiqLoaderService();
      }
      return CiqLoaderService.instance;
    }
  
    private ensureLoaderExists() {
      let loader = document.querySelector<HTMLCiqLoaderElement>('ciq-loader');
      
      if (!loader) {
        loader = document.createElement('ciq-loader');
        document.body.appendChild(loader);
      }
  
      this.loaderComponent = loader;
    }
  
    show(message: string = 'Loading...', forDialog?: boolean, messages?: string[], autoHideAfterMs?: number,) {
        
      if (this.loaderComponent) {
        this.loaderComponent.open = true;
        this.loaderComponent.forDialog = (typeof forDialog !== 'undefined' && forDialog);
        this.loaderComponent.message = message;
  
        if (autoHideAfterMs) {
          setTimeout(() => this.hide(), autoHideAfterMs);
        }
        if (messages) {
            console.log(messages);  
          this.updateText(0, messages);
        }
      }
    }

    private updateText(index: number, messageArray: string[]) {
        this.loaderComponent.message = messageArray[index];
        index++;
        
        // If there are more strings in the array, schedule the next update
        if (index < messageArray.length) {
          this.timeoutid = setTimeout(()=>{
            this.updateText(index, messageArray)
        }, 10000); // Wait for 20 seconds before the next update
        }
      }
  
    hide() {
      if (this.loaderComponent) {
        this.loaderComponent.open = false;
        if (this.timeoutid){
            clearTimeout(this.timeoutid);
        }
       
      }
    }
  }
  
  export const loaderService = CiqLoaderService.getInstance();